import { render, staticRenderFns } from "./cooperationView.vue?vue&type=template&id=681b333e&scoped=true"
import script from "./cooperationView.vue?vue&type=script&lang=js"
export * from "./cooperationView.vue?vue&type=script&lang=js"
import style0 from "./cooperationView.vue?vue&type=style&index=0&id=681b333e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b333e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681b333e')) {
      api.createRecord('681b333e', component.options)
    } else {
      api.reload('681b333e', component.options)
    }
    module.hot.accept("./cooperationView.vue?vue&type=template&id=681b333e&scoped=true", function () {
      api.rerender('681b333e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/cooperationView.vue"
export default component.exports